var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownMenu',{attrs:{"name":"Dataset"}},_vm._l((_vm.customStore.state.datasets),function(dataset){return _c('DropdownMenuItem',{key:dataset,attrs:{"name":dataset,"value":`dataset_name:${dataset}`}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }